import { EstimateStatus } from '@/types/estimates/EstimateStatus';
import { getEstimateStatusLabel } from '@/utils/estimates/getEstimateStatusLabel';
import { useTranslation } from '@/i18n';
import { useMemo } from 'react';

interface EstimateStatusCellProps {
  status: EstimateStatus;
  isReceiver?: boolean;
}

const EstimateStatusCell = ({
  status,
  isReceiver = false,
}: EstimateStatusCellProps) => {
  const { t } = useTranslation();
  const colorMap = {
    [EstimateStatus.ESTIMATE]: 'border-sky-200 bg-sky-50 text-sky-700',
    [EstimateStatus.PENDING]: 'border-brand-200 bg-brand-50 text-brand-600',
    [EstimateStatus.RESERVED]:
      'border-success-200 bg-success-50 text-success-700',
    [EstimateStatus.REFUSED]:
      'border-warning-200 bg-warning-50 text-warning-700',
  };

  const label = useMemo(
    () => getEstimateStatusLabel(status, isReceiver, t),
    [isReceiver, status, t],
  );

  return (
    <span
      className={`px-2 py-0.5 border rounded-lg text-sm font-medium whitespace-nowrap ${colorMap[status]}`}
    >
      {label}
    </span>
  );
};

export default EstimateStatusCell;
